import React from 'react';
import { useNavigate } from 'react-router-dom';
import Typography from 'carbon-react/lib/components/typography';
import Button from 'carbon-react/lib/components/button';

import { FormattedMessage } from '@futrli/localisation';

import styles from './header.scss';

export const Header = () => {
  const navigate = useNavigate();

  const handleExitClick = () => {
    navigate(-1);
  };

  return (
    <div className={styles.appBar}>
      <div className={styles.carbonHeaderBar}>
        <div className={styles.carbonHeaderContent}>
          <Typography variant="h1" fontWeight="500" fontSize="18px">
            <FormattedMessage id="common.my_profile" defaultMessage="My Profile" />
          </Typography>
          <Button onClick={handleExitClick} type="secondary">
            <FormattedMessage id="common.exit" defaultMessage="Exit" />
          </Button>
        </div>
      </div>
    </div>
  );
};
